/**
 * 接口域名的管理
 */
const base = {
  sq: 'https://xxxx111111.com/api/v1',
  // bd: 'http://54.254.144.189:8086'
  bd: 'https://einstein.redtea.io'
}

export default base
